export default {
	path: 'articles',
	name: 'ArticleForm',
	component() {
		return import('@/components/article/ArticleForm.vue')
	},
	children: [
		{
			path: '',
			name: 'ArticleList',
			component() {
				return import('@/components/article/article/ArticleList.vue')
			},
		},
		{
			path: ':id',
			name: 'ArticleDetail',
			component() {
				return import('@/components/article/article/ArticleDetail.vue')
			},
		},
		{
			path: 'toBePub',
			name: 'ArticleToBePubList',
			component() {
				return import('@/components/article/articleToBePub/ArticleToBePubList.vue')
			},
		},
		{
			path: 'toBePub/:id',
			name: 'ArticleToBePubDetail',
			component() {
				return import('@/components/article/articleToBePub/ArticleToBePubDetail.vue')
			},
		},
		{
			path: 'over',
			name: 'ArticleCarryoverList',
			component() {
				return import('@/components/article/articleCarryingForward/ArticleCarryingForwardList.vue')
			},
		},
		{
			path: 'over/:id',
			name: 'ArticleCarryoverDetail',
			component() {
				return import('@/components/article/articleCarryingForward/ArticleCarryingForwardDetail.vue')
			},
		},
		{
			path: 'bc',
			name: 'BookChapterList',
			component() {
				return import('@/components/article/bookChapter/BookChapterList.vue')
			},
		},
		{
			path: 'bc/:id',
			name: 'BookChapterDetail',
			component() {
				return import('@/components/article/bookChapter/BookChapterDetail.vue')
			},
		},
		{
			path: 'cs',
			name: 'ArticleComputerScienceList',
			component() {
				return import('@/components/article/articleComputerScience/ArticleComputerScienceList.vue')
			},
		},
		{
			path: 'cs/:id',
			name: 'ArticleComputerScienceDetail',
			component() {
				return import('@/components/article/articleComputerScience/ArticleComputerScienceDetail.vue')
			},
		},
	],
}